export const MENUS_BASE_PATH = '/navigation';

export const MENUS_ROUTES = {
  menus: MENUS_BASE_PATH,
};
